import React from 'react';
import Box from '@mui/system/Box';
import BrandsLinks from 'components/Elements/BrandsLinks';
import { useIntl } from 'react-intl';
import { Status } from 'typings/enums';
import * as Styled from './BrandLinksContainer.styles';
import useBrands from '../../hooks/useBrands';
import { definedTranslation } from '../../i18n';

const BrandLinksContainer: React.FC = () => {
  const { filteredBrands, filterValue, brandsStatus } = useBrands();
  const intl = useIntl();

  const labels = {
    soon: intl.formatMessage(definedTranslation.soon),
    new: intl.formatMessage(definedTranslation.new),
  };

  const NoFilterValueComponent = () => {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="100%"
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          mt="80px"
          alignItems="center"
        >
          <Styled.TextBox variant="body" fontWeight="600">
            No Results
          </Styled.TextBox>
          <Styled.TextBox variant="body">
            We couldn’t find anything for your search
          </Styled.TextBox>
        </Box>
      </Box>
    );
  };

  if (
    filteredBrands?.length === 0 &&
    filterValue !== '' &&
    brandsStatus === Status.LOADED
  ) {
    return <NoFilterValueComponent />;
  }

  return (
    <BrandsLinks
      // @ts-expect-error // TODO: fix types
      brands={filteredBrands || []}
      status={brandsStatus}
      labels={labels}
    />
  );
};

export default BrandLinksContainer;
